import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DialogModel} from '@shared/models/dialog.model';
import {select, Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {ParticleCacheService} from '@core/services/particle-cache.service';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {takeUntil} from 'rxjs/operators';
import {ParticleCacheModel} from '@shared/models/particle-cache.model';
import {QueryProvider} from '@shared/queries/query-provider';
import {Subject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-dump-demo-data',
  templateUrl: './dump-demo-data.component.html',
  styleUrls: ['./dump-demo-data.component.scss']
})
export class DumpDemoDataComponent implements OnInit, OnDestroy {

  formGroup: FormGroup;
  data: DialogModel;
  comment: string;
  demos$: any;
  demo: any;

  private ngUnsubscribe = new Subject<void>();

  constructor(private queryState: Store<IQueryState>,
              private formBuilder: FormBuilder,
              private particleCacheService: ParticleCacheService,
  ) {}

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      demo : [this.demo, Validators.required],
      comment : ['', Validators.required]
    });
    this.demos$ = this.queryState.pipe(select(getQueryResponse, 'DemoConfig'));
    this.demos$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(demos => {
      if (demos && demos.length) {
        demos.forEach((item) => {
          const toolTipCacheKey = `tool-tip-${item.companyId}`;
          this.particleCacheService.clearItem([toolTipCacheKey]);

          if (item.tooltips && item.tooltips.length) {
            const toolTips = {};
            item.tooltips.forEach((toolTip) => {
              toolTips[`${toolTipCacheKey}-${toolTip.key}`] = toolTip;
            });
            const toolTipCaches: ParticleCacheModel = {
              type   : toolTipCacheKey,
              value  : toolTips,
              version: '0.0.0'
            };
            this.particleCacheService.saveItem(toolTipCacheKey, toolTipCaches);
          }
        });
        this.demo = demos[0];
        this.formGroup.controls['demo'].setValue(this.demo);
      }
    });

    QueryProvider.invokeQuery(this.queryState, 'DemoConfig', {});
  }

  onOkClicked() {
    this.data.input['selectedDemo'] = this.formGroup.controls['demo'].value;
    this.data.input['comment'] = this.formGroup.controls['comment'].value;
    return true;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
